import { render, staticRenderFns } from "./CreatePdfArchiveModalForm.vue?vue&type=template&id=099f8d3d"
import script from "./CreatePdfArchiveModalForm.vue?vue&type=script&lang=ts"
export * from "./CreatePdfArchiveModalForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('099f8d3d')) {
      api.createRecord('099f8d3d', component.options)
    } else {
      api.reload('099f8d3d', component.options)
    }
    module.hot.accept("./CreatePdfArchiveModalForm.vue?vue&type=template&id=099f8d3d", function () {
      api.rerender('099f8d3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pdf-archive/CreatePdfArchiveModalForm.vue"
export default component.exports